// eslint-disable-next-line import/prefer-default-export
export const getVisibility = (state) => (state.navBar.visibility);
export const getTransparency = (state) => (state.navBar.transparency);
export const getLinkColor = (state) => (state.navBar.linkColor);
export const getTheme = (state) => (state.navBar.theme);
